import { Translation } from "../../hooks/useTranslations";
import { Entity, Version } from "../../types";

export type Subsidiary = Entity & {
  name: string;
  allowMultiPlates: boolean;
  vatDeductionCode?: string;
  vatServiceCode?: string;
  countryIsoCodeAlpha2?: string;
  defaultLanguage?: string;
  semiramisOrganizationCode: string;
};

export type SubsidiaryVersion = Version & {
  name: string;
  allowMultiPlates: boolean;
  vatDeductionCode?: string;
  vatServiceCode?: string;
  countryIsoCodeAlpha2?: string;
  defaultLanguage?: string;
  semiramisOrganizationCode?: string;
};

export type UpsertSubsidiary = {
  name: string;
  allowMultiPlates: boolean;
  vatDeductionCode?: string;
  vatServiceCode?: string;
  countryIsoCodeAlpha2?: string;
  defaultLanguage?: string;
  currentVersionNumber?: number;
  semiramisOrganizationCode: string;
};

export type UpsertIsoCode = {
  countryIsoCodeAlpha2?: string;
  currentVersionNumber: number;
};

export type Language = {
  value: string;
  label: string;
};

export const getLanguages = (t: Translation): Language[] => [
  { value: "it", label: t.common.italian },
  { value: "en", label: t.common.englishUk },
  { value: "fr", label: t.common.french },
  { value: "de", label: t.common.german },
  { value: "es", label: t.common.spanish },
  { value: "lt", label: t.common.lithuanian },
  { value: "lv", label: t.common.latvian },
  { value: "br-en", label: t.common.englishBrasil },
];
